@if (fieldPath) {
  <div class="tts-scrim" (click)="close.emit()"></div>

  <aside class="tts-panel">
    <header class="tts-panel-header">
      <div>
        <div class="tts-eyebrow">SPOKEN AUDIO</div>
        <div class="tts-panel-title">{{ label }}</div>
      </div>
      <button type="button" class="tts-close" (click)="close.emit()" aria-label="Close">✕</button>
    </header>

    <div class="tts-panel-body">
      @if (theme; as t) {
        <div class="tts-status-row" [style.background]="t.bg" [style.borderColor]="t.border">
          <span class="tts-status-badge">
            <svg viewBox="0 0 24 24" [attr.fill]="t.text" aria-hidden="true">
              <path d="M5 9v6h4l5 5V4l-5 5H5z" />
              <path d="M16.5 8.5a5 5 0 010 7" [attr.stroke]="t.text" stroke-width="1.8" fill="none" stroke-linecap="round" />
            </svg>
            <span class="tts-status-dot" [style.background]="t.dot"></span>
          </span>
          <div>
            <div class="tts-status-title" [style.color]="t.text">{{ t.title }}</div>
            <div class="tts-status-detail">{{ detail }}</div>
          </div>
        </div>
      }

      <div>
        <div class="tts-eyebrow">TEXT</div>
        @if (spokenText) {
          <p class="tts-text">{{ spokenText }}</p>
        } @else {
          <p class="tts-text tts-text-empty">This field is empty.</p>
        }
      </div>

      <!-- No failure reason on purpose: none is stored or returned. -->

      @if (!isFailed) {
        <div>
          <div class="tts-eyebrow">PREVIEW</div>
          @if (hasAudio) {
            <audio class="tts-player" controls preload="metadata" [src]="row?.url"></audio>
          } @else {
            <div class="tts-player-placeholder">
              @if (isPending) {
                <span class="tts-spinner"></span>
              }
              <span>{{ isPending ? 'Generating audio…' : 'No audio yet' }}</span>
              <span class="tts-duration">--:--</span>
            </div>
          }
        </div>
      }

      @if (settingRows.length) {
        <div class="tts-settings">
          <button type="button" class="tts-settings-toggle" [attr.aria-expanded]="settingsOpen" (click)="toggleSettings()">
            <span>VOICE SETTINGS</span>
            <span class="tts-chevron" [class.open]="settingsOpen">›</span>
          </button>

          @if (settingsOpen) {
            <div class="tts-settings-body">
              @for (s of settingRows; track s.label) {
                <div class="tts-setting">
                  <span class="tts-setting-label">{{ s.label }}</span>
                  <span class="tts-setting-value">{{ s.value }}</span>
                </div>
              }
              <p class="tts-note">What this field's audio was generated with. Changing it is not available here.</p>
            </div>
          }
        </div>
      }
    </div>

    <footer class="tts-panel-footer">
      @if (regenerateError) {
        <div class="tts-error">{{ regenerateError }}</div>
      }
      @if (formDirty) {
        <div class="tts-note">Save your changes before regenerating this field's audio.</div>
      }

      <button type="button" class="tts-regenerate" [disabled]="!canRegenerate" (click)="regenerate()">
        {{ isPending ? 'Generating…' : regenerating ? 'Starting…' : isNotGenerated ? 'Generate audio' : 'Regenerate audio' }}
      </button>
    </footer>
  </aside>
}
